





import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Partner } from '@/modules/kartoteka/partner';

import { store } from '../../store/edit';
import { editActions, editMutations } from '../../store/types';

export default Vue.extend({
	name: 'ZapujckaZakaznikSelect',
	components: { PartnerSelect: Partner.components.Select },
	props: {
		storeUri: String,
		disabled: { type: Boolean, default: false },
		isViewable: { type: Boolean, default: false },
	},
	computed: {
		...genVuexComputeds(store),
		zapujckaFilter(): { ZakaznikId: number | null, Zapujcka: boolean } {
			return {
				ZakaznikId: this.ZakaznikId,
				Zapujcka: true,
			};
		},
		mutationsMappers() : Record<string, string> {
			return {
				partnerSelect: `${this.storeUri}/${editMutations.ZAPUJCKA_PARTNER_SELECT_MAPPER}`,
			};
		},
		actions() : Record<string, string> {
			return {
				zakaznikChange: `${this.storeUri}/${editActions.ZAKAZNIK_CHANGE}`,
			};
		},
	},
});
